<template>
  <div class="staticNotify" :style="{backgroundColor: bgColor,borderColor: brColor}">
    <div class="vc">
      <div class="left">
        <i class="iconfont" :style="{color: brColor,fontSize: '16px'}">&#xe65e;</i>
      </div>
      <div class="right">
        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StaticNotify',
  props: {
    bgColor: { // 背景颜色
      type: String,
      default: '#fff3cd'
    },
    color: { // 字体颜色
      type: String,
      default: '#333'
    },
    icon: {
      type: String,
      default: 'iconfont'
    },
    brColor: {
      type: String,
      default: '#FFC107'
    },
    top: {
      type: Number,
      default: 16
    }
  }

}
</script>

<style lang="scss" scoped>
.staticNotify {
	padding: 20px 0;
	border: 1px solid;
	.vc {
		display: flex;
	}
	.left {
		width: 50px;
		text-align: center;
	}
	.right {
		flex: 1;
		line-height: 1.5;
	}

}

</style>
